module.exports = __webpack_public_path__ + "img/cloud.d3684264.png";